module.exports = __webpack_public_path__ + "img/Labylok.495eff6e.gif";